import flatpickr from 'flatpickr';
import German from 'flatpickr/dist/l10n/de.js';

const FLAT_PICKR_OPTIOINS = {
    maxDate: new Date(),
    altFormat: 'd. m. Y',
    altInput: true,
    locale: document.documentElement.lang || 'en',
    // we need this for HTML 5 validation
    // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
    allowInput: true
};

window.emitter.on('preselect-form', event => {
    // Split mulitple values with /
    event.preselect.split('#').forEach(value => {
        let category;

        if (value.includes('.')) {
            category = value.split('.')[0];
            value = value.split('.')[1];
        }

        [...document.querySelectorAll(`input[value="${value}"]`)].forEach(input => {
            input.click();
            setTimeout(function() {
                const slider = input.closest('.form-section.slider');
                if (slider && category) {
                    const flkty = window.Flickity.data(slider);
                    let slideId = 0;
                    if (category == 'body') {
                        slideId = 1;
                    } else if (category == 'face') {
                        slideId = 2;
                    }
                    if (category == 'hair') {
                        slideId = 3;
                    }
                    flkty.select(slideId);
                }
            }, 100);
        });
    });
});

const preselect = location.hash.substr(1);

if (preselect) {
    window.emitter.emit('preselect-form', { preselect });
}

[...document.querySelectorAll('.input--date')].forEach(element => {
    const INPUT_ELEMENT = element.querySelector('.input__field');
    if (!INPUT_ELEMENT) {
        return;
    }
    flatpickr(INPUT_ELEMENT, FLAT_PICKR_OPTIOINS);

    // we need this for HTML 5 validation
    // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
    INPUT_ELEMENT.nextElementSibling.onkeypress = () => false;

    //const flatPickr = flatpickr(INPUT_ELEMENT, FLAT_PICKR_OPTIOINS);
    // flatPickr.config.onChange.push(selectedDates => {
    //     if (selectedDates.length > 0) {
    //         minDepartureDate = selectedDates[0];
    //     }
    // });
});

// hide select box overlay if value is selected:

[...document.querySelectorAll('.form select')].forEach(selectbox => {
    selectbox.onchange = function() {
        selectbox.classList.add('valid');
    };
});

const consultationForm = document.getElementById('consultationForm');

document.addEventListener('click', event => {
    if (event.target.classList.contains('contact-form__trigger')) {
        setTimeout(() => {
            [...document.querySelectorAll('.slider')].forEach(slider => {
                window.Flickity.data(slider).resize();
            });
        }, 0);
    }

    if (consultationForm) {
        // Check if the clicked element is a link
        if (event.target.tagName === 'A') {
            const anchor = event.target;
            const currentUrl = window.location.href.split('#')[0];
            const targetUrl = anchor.href.split('#')[0];

            // If the base URL is the same but the hash is different, force reload
            if (currentUrl === targetUrl && window.location.hash !== anchor.hash) {
                event.preventDefault();
                window.location.hash = anchor.hash;
                window.location.reload();
            }
        } 
    }
});
